import { callAPI, HTTPMethod, getAuthenticatedGetUrl } from "./API";
import { Documents, Document, DocumentsQueryParams, DocumentRequest } from "../model/Document";

const basePath = (tenantId: string) => `/tenants/${tenantId}/documents`;

export async function listCustomerDocuments(tenantId: string, page: number, offset: number, params: DocumentsQueryParams): Promise<Documents> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.GET,
        query: {
            search: params.search,
            page_size: page.toString(),
            offset: offset.toString()
        }
    });
}

export async function createCustomerDocument(tenantId: string, request: DocumentRequest): Promise<Document> {
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function getCustomerDocument(tenantId: string, id: string): Promise<Document> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.GET
    });
}

export async function updateCustomerDocument(tenantId: string, id: string, request: DocumentRequest): Promise<Document> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function deleteCustomerDocument(tenantId: string, id: string): Promise<any> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.DELETE
    });
}

export async function getDocumentUrl(tenantId: string, id: string): Promise<string> {
    return getAuthenticatedGetUrl(`${basePath(tenantId)}/${id}/file`);
}